import serviceAxios from "../http/index";
// 首页信息
export const getIndexData = (params) => {
  return serviceAxios({
    url: "/index",
    method: "get",
    params,
  });
};
// 首页导航
export const getMenuData = (params) => {
  return serviceAxios({
    url: "/index/getMenuData",
    method: "get",
    params,
  });
};
// 联系我们
export const getContactData = (params) => {
  return serviceAxios({
    url: "/meeting/getContactData",
    method: "get",
    params,
  });
};
// 大会详情
export const getMeetingData = (params) => {
  return serviceAxios({
    url: "/meeting/getMeetingData",
    method: "get",
    params,
  });
};
// 大会时间
export const getMeetingDate = (params) => {
  return serviceAxios({
    url: "/meeting/getMeetingDate",
    method: "get",
    params,
  });
};
// 会议动态
export const getMeetingNew = (params) => {
  return serviceAxios({
    url: "/meeting/getMeetingTrends",
    method: "get",
    params,
  });
};
// 往届精彩
export const getPreviousData = (params) => {
  return serviceAxios({
    url: "/meeting/getPrevious",
    method: "get",
    params,
  });
};
// 动态详情
export const getNewsDetail = (params) => {
  return serviceAxios({
    url: "/meeting/getMeetingTrendsDetail",
    method: "get",
    params,
  });
};

// 分会场
export const getDivideData = (params) => {
  return serviceAxios({
    url: "/meeting/getDivideData",
    method: "get",
    params,
  });
};

// 分会场详情

export const getScheduleContent = (params) => {
  return serviceAxios({
    url: "/meeting/getScheduleContent",
    method: "get",
    params,
  });
};
// 日程安排
export const getScheduleData = (params) => {
  return serviceAxios({
    url: "/meeting/getProgramData",
    method: "get",
    params,
  });
};

// 组织架构
export const getInstitutionData = (params) => {
  return serviceAxios({
    url: "/meeting/getInstitutionArrayData",
    method: "get",
    params,
  });
};

// 友情链接
export const getLinkData = (params) => {
  return serviceAxios({
    url: "/meeting/getLinkData",
    method: "get",
    params,
  });
};

// 会议概况
export const getOverviewData = (params) => {
  return serviceAxios({
    url: "/index/getOverviewData",
    method: "get",
    params,
  });
};

// 组委会
export const getCommitteeData = (params) => {
  return serviceAxios({
    url: "/meeting/getCommitteeData",
    method: "get",
    params,
  });
};

// 参会指南
export const getGuideData = (params) => {
  return serviceAxios({
    url: "/meeting/geGuideData",
    method: "get",
    params,
  });
};

// 参展指南
export const getExhibitionData = (params) => {
  return serviceAxios({
    url: "/meeting/getExhibitionData",
    method: "get",
    params,
  });
};
// 资料下载
export const getDownloadData = (params) => {
  return serviceAxios({
    url: "/meeting/getMeetingDownload",
    method: "get",
    params,
  });
};

// 模板下载
export const getTemplateData = (params) => {
  return serviceAxios({
    url: "/index/getTemplateData",
    method: "get",
    params,
  });
};








// WEBPACK FOOTER //
// ./src/api/home.js